import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash, FaLock, FaUser, FaArrowRight } from 'react-icons/fa';
import backgroundIllustration from '../assets/couple.png';
import '../css/Login.css';
import { useTranslation } from 'react-i18next';
import { GoogleLogin } from '@react-oauth/google';


function Connexion() {
  const navigate = useNavigate();
  const [identifiant, setIdentifiant] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [afficherMotDePasse, setAfficherMotDePasse] = useState(false);
  const [chargement, setChargement] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const { t } = useTranslation();


  useEffect(() => {
    const savedUser = localStorage.getItem('rememberedUser');
    if (savedUser) {
      setIdentifiant(savedUser);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setChargement(true);
    setErreur('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        username: identifiant,
        password: motDePasse
      });

      const token = response.data.token;
      localStorage.setItem('authToken', token);

      const userInfo = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const user = userInfo.data;
      console.log("CURRENT USER:", user);
      console.log("CURRENT ROLE:", user.role);
      localStorage.setItem('currentUser', JSON.stringify(user));

      if (rememberMe) {
        localStorage.setItem('rememberedUser', identifiant);
      } else {
        localStorage.removeItem('rememberedUser');
      }
      const isIncomplete =
        !user.bio || !user.gender || !user.mediaUrls || user.mediaUrls.length === 0;

      if (user.role === "ROLE_ADMIN") {
        navigate("/admin");
      } else if (isIncomplete) {
        navigate("/mon-profil");
      } else {
        navigate("/suggestions");
      }


    } catch (error) {
      console.error("Échec de la connexion", error);
      setErreur(error.response?.data?.message || "Identifiants incorrects. Veuillez réessayer.");
    } finally {
      setChargement(false);
    }
  };

  return (
    <div className="conteneur-connexion">
      <div className="carte-connexion">
        <div className="cote-gauche">
          <img src={backgroundIllustration} alt={t('login.coupleAlt')} className="image-connexion" />
          <div className="overlay-connexion">
            <h2>{t('login.heroTitle')}</h2>
            <p>{t('login.heroSubtitle')}</p>
          </div>
        </div>

        <div className="cote-droit">
          <div className="en-tete-connexion">
            <img src={require('../assets/logo1.png')} alt="Logo MyHalal" className="logo-connexion" />
            {/* <h2>{t('login.welcomeBack')}</h2>
            <p>{t('login.pleaseLogin')}</p> */}
          </div>

          <form onSubmit={handleSubmit} className="formulaire-connexion">
            {erreur && <div className="erreur-connexion">{erreur}</div>}

            <div className="groupe-input">
              <FaUser className="icone-input" />
              <input
                type="text"
                placeholder={t('login.usernameOrEmail')}
                value={identifiant}
                onChange={(e) => setIdentifiant(e.target.value)}
                required
              />
            </div>

            <div className="groupe-input">
              <FaLock className="icone-input" />
              <input
                type={afficherMotDePasse ? "text" : "password"}
                placeholder={t('login.password')}
                value={motDePasse}
                onChange={(e) => setMotDePasse(e.target.value)}
                required
              />
              <button
                type="button"
                className="bouton-visibilite"
                onClick={() => setAfficherMotDePasse(!afficherMotDePasse)}
                aria-label={afficherMotDePasse ? t('login.hidePassword') : t('login.showPassword')}
              >
                {afficherMotDePasse ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <div className="options-connexion">
              <label className="se-souvenir">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                /> {t('login.rememberMe')}
              </label>
              <Link to="/forget" className="lien-mot-de-passe">
                {t('login.forgotPassword')}
              </Link>
            </div>

            <button type="submit" className="bouton-connexion" disabled={chargement}>
              {chargement ? t('login.loggingIn') : t('login.loginButton')} <FaArrowRight />
            </button>

            <div className="separateur-connexion">
              <span>{t('login.or')}</span>
            </div>

            <div className="connexion-sociale">
              <div className="google-wrapper">
                <GoogleLogin
                  width="100%"
                  size="large"
                  theme="outline"
                  text="signin_with"
                  shape="pill"
                  onSuccess={async (credentialResponse) => {
                    try {
                      const { credential } = credentialResponse;
                      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/google`, {
                        token: credential
                      });

                      const token = response.data.token;
                      localStorage.setItem('authToken', token);

                      const userInfo = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/me`, {
                        headers: { Authorization: `Bearer ${token}` }
                      });

                      localStorage.setItem('currentUser', JSON.stringify(userInfo.data));
                      const user = userInfo.data;

                      const isIncomplete =
                        !user.bio || !user.gender || !user.mediaUrls || user.mediaUrls.length === 0;

                      if (isIncomplete) {
                        navigate("/mon-profil"); // ✅ redirection vers profil
                      } else {
                        navigate("/suggestions");  // ✅ redirection normale
                      }

                    } catch (error) {
                      console.error("Erreur lors de la connexion Google :", error);
                      setErreur("Connexion avec Google échouée. Veuillez réessayer.");
                    }
                  }}

                />
              </div>
            </div>

            <p className="lien-inscription">
              {t('login.noAccount')} <Link to="/register">{t('login.register')}</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );

}

export default Connexion;
